export enum AnnouncedTeamStatus {
  ANNOUNCED = 'announced',
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  DECLINED = 'declined',
}
